import { MapOverviewView } from "../views/mapOverviewView.jsx";
import locationTask from "../data/locationTask.json";
import images from "../images/images.js";
import store from "../util/store.jsx";
import locationInfo from "../data/locationInfo.json"

function MapOverview() {
  const state = store.getState();
  const { firstName } = state.userData.userProfile;

  function goToProfileACB() {
    window.location.hash = "#/profile";
  }

  return (
    <MapOverviewView
      locationInfo={locationInfo}
      images={images}
      firstName={firstName}
      onProfile={goToProfileACB}
    />
  );
}

export { MapOverview };
